import fileImg from "../../../assets/icons/file_blue.svg";
import deleteImage from "../../../assets/icons/delete_plus.svg";

import {
    deleteAttachmentThunkAction,
} from "../../../redux/actions/Requests/Attachments/thunk/deleteAttachment.thunk.action";
import {
    getRequestAttachmentsURLThunkAction,
} from "../../../redux/actions/Requests/Attachments/thunk/getRequestAttachmentsURL.thunk.action";
import RequestServices from "../../../frontend.services/RequestServices/RequestServices";

import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {ClipLoader} from "react-spinners";
import {useSearchParams} from "react-router-dom";

import "./RequestAttachments.scss";

const FileSaver = require("file-saver");


const RequestAttachments = (
    {
        deleteIcon,
    }
) => {
    const dispatch = useDispatch();

    const [searchParams] = useSearchParams();
    const requestUid = searchParams.get("id");

    const requestAttachments = useSelector(state => state.requests.requestAttachments);
    const currentRequest = useSelector(state => state.requests.currentRequest);

    const [deleteStatus, setDeleteStatus] = useState(false);

    function deleteAttachment(e) {
        dispatch(deleteAttachmentThunkAction(
            {attachId: e.target.id, requestId: currentRequest.uid, setDeleteStatus}
        ));
    }


    useEffect(() => {
        dispatch(getRequestAttachmentsURLThunkAction(requestUid));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [requestAttachments.length]);

    return requestAttachments ? (
        <div>
            {requestAttachments && requestAttachments.map(e => {
                return (
                    <div
                        className="custom-uploader__item"
                        key={e.id}>
                        <img
                            className="custom-uploader__item__img"
                            src={fileImg}
                            alt="file"/>
                        <div style={{position: "relative"}} className="custom-uploader__item__link">
                            <a
                                target="_blank"
                                // href={e.blobLink}
                                onClick={()=>(FileSaver.saveAs(e.blobLink, e.fileName))}
                                className="custom-uploader__item__name" rel="noreferrer">
                                    {/*<div className="custom-uploader__item__name__label">*/}
                                        {e.fileName}
                                    {/*</div>*/}

                            </a>

                        </div>
                        {
                            deleteIcon ? null :
                                deleteStatus ? <ClipLoader color="#6DCDF6" size={32}/> :
                                    <div
                                        className="custom-uploader__item__delete">
                                        <img
                                            id={e.id}
                                            onClick={deleteAttachment}
                                            src={deleteImage}
                                            alt="delete"/>
                                    </div>
                        }
                    </div>
                );
            })}
        </div>
    ) : <ClipLoader color="#6DCDF6"/>;
};

export default RequestAttachments;
